import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as BonusDescontoActions } from "../ducks/bonusDesconto";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";
import { formatReal } from "../../helpers";
import moment from "moment";

export function* getListBonusDesconto() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(
      state => state.bonusDesconto
    );

    const { date_type, initial_date, finish_date } = yield select(
      state => state.filtrosBonusDesconto
    );

    if (!filter.search) {
      filter.date_type = date_type.split("-", 1)[0];
      filter.initial_date = moment(initial_date).format("DD/MM/YYYY");
      filter.finish_date = moment(finish_date).format("DD/MM/YYYY");
    }

    if (filter.type === "") {
      delete filter.type;
    }

    const { data } = yield call(
      api.post,
      `/bonus-discounts/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );

    const { total } = data;

    let bonusDescontoPayload = [];

    bonusDescontoPayload = data.data.map(bonusDesconto => ({
      ...bonusDesconto,
      created_at: moment(bonusDesconto.created_at).format("DD/MM/YYYY"),
      type: bonusDesconto.type === "desconto" ? "Desconto" : "Bônus",
      destinable_type:
        bonusDesconto.destinable_type === "stores" ? "Lojas" : "Vendedores",
      amount: `<span class="flex-end">${formatReal(
        bonusDesconto.amount
      )}</span>`,
      pago: !!bonusDesconto.done
        ? `<i class="fa fa-check-square fs2 mr1"></i>`
        : "",
      current_at: bonusDesconto.current_at
        ? moment(bonusDesconto.current_at).format("DD/MM/YYYY")
        : ""
    }));

    const name = "Bônus/Descontos Programados";
    const path = "bonus-desconto";
    yield put(PageActions.setPage(name, path));
    yield put(
      BonusDescontoActions.getListBonusDescontoSuccess(
        bonusDescontoPayload,
        total
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getBonusDesconto({ payload }) {
  try {
    const { action } = yield select(state => state.bonusDescontoStores);
    if (action !== "DETAILS INVOICE" && action !== "EDIT INVOICE") {
      yield put(LoadingActions.setLoading());
      const { data } = yield call(api.get, `/bonus-discounts/${payload.id}`);
      yield put(BonusDescontoActions.getBonusDescontoSuccess(data));
    } else {
      yield put(LoadingActions.setLoading());
      const { data } = yield call(api.get, `/bonus-discounts/${payload.id}`);
      yield put(BonusDescontoActions.getBonusDescontoSuccess(data));
    }
    if (
      action === "EDIT" ||
      action === "DETAIL" ||
      action === "DETAILS INVOICE" ||
      action === "EDIT INVOICE"
    ) {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O(s) cadastro(s) serão excluídos do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editBonusDesconto({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { action } = yield select(state => state.bonusDescontoStores);
    if (action !== "EDIT INVOICE") {
      yield call(api.put, `/bonus-discounts/${payload.id}`, payload);
    } else {
      yield call(api.put, `/bonus-discounts/${payload.id}`, payload);
    }
    yield put(BonusDescontoActions.getListBonusDesconto());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addBonusDesconto({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/bonus-discounts`, payload);
    yield put(BonusDescontoActions.searchBonusDesconto({}));
    yield put(BonusDescontoActions.getListBonusDesconto());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteBonusDesconto() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.bonusDesconto.item);
    yield call(api.delete, `/bonus-discounts/${id}`);
    yield put(BonusDescontoActions.getListBonusDesconto());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* deleteBonusDescontoParcela() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.bonusDesconto.item);
    yield call(api.delete, `/bonus-discounts/${id}`);
    yield put(BonusDescontoActions.getListBonusDesconto());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchBonusDesconto() {
  try {
    yield put(BonusDescontoActions.getListBonusDesconto());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListBonusDescontoSelects() {
  try {
    const { data: bonusDesconto } = yield call(
      api.get,
      `/bonus-discounts/select`
    );
    yield put(
      BonusDescontoActions.getListBonusDescontoSuccessSelects(bonusDesconto)
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllBonusDesconto({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/bonus-discounts/destroy-many`, {
      bonus_discounts_id: payload.selected
    });
    yield put(BonusDescontoActions.getListBonusDesconto());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/bonusDesconto.js